/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Content.MediaItemType_
///   This is an auto-generated enumeration of the SWFC_Learning.Content.MediaItemType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum MediaItemType_ {
   /// <summary>
   ///   BrightCove Video (EV)
   /// </summary>
   BrightCoveVideo = 1,
   /// <summary>
   ///   Image (IM)
   /// </summary>
   Image = 2,
   /// <summary>
   ///   HTML5 (HT)
   /// </summary>
   HTML5 = 3,
   /// <summary>
   ///   SWF OBJECT (SW)
   /// </summary>
   SWF = 4,
   /// <summary>
   ///   Worksheet (WS)
   /// </summary>
   Worksheet = 5,
   /// <summary>
   ///   YouTube Video (YV)
   /// </summary>
   YouTubeVideo = 6,
   /// <summary>
   ///   eBook (EB)
   /// </summary>
   eBook = 7,
   /// <summary>
   ///   Vimeo Video (VV)
   /// </summary>
   VimeoVideo = 8
}

export const MediaItemTypes: MediaItemType[] = [
   {
      code: MediaItemType_.BrightCoveVideo,
      literal: 'BrightCoveVideo',
      description: 'BrightCove Video',
      shortDescription: 'EV',
      listPriority: 0,

      typeName: "MediaItemType"
   },
   {
      code: MediaItemType_.Image,
      literal: 'Image',
      description: 'Image',
      shortDescription: 'IM',
      listPriority: 1,

      typeName: "MediaItemType"
   },
   {
      code: MediaItemType_.HTML5,
      literal: 'HTML5',
      description: 'HTML5',
      shortDescription: 'HT',
      listPriority: 2,

      typeName: "MediaItemType"
   },
   {
      code: MediaItemType_.SWF,
      literal: 'SWF',
      description: 'SWF OBJECT',
      shortDescription: 'SW',
      listPriority: 3,

      typeName: "MediaItemType"
   },
   {
      code: MediaItemType_.Worksheet,
      literal: 'Worksheet',
      description: 'Worksheet',
      shortDescription: 'WS',
      listPriority: 4,

      typeName: "MediaItemType"
   },
   {
      code: MediaItemType_.YouTubeVideo,
      literal: 'YouTubeVideo',
      description: 'YouTube Video',
      shortDescription: 'YV',
      listPriority: 5,

      typeName: "MediaItemType"
   },
   {
      code: MediaItemType_.eBook,
      literal: 'eBook',
      description: 'eBook',
      shortDescription: 'EB',
      listPriority: 6,

      typeName: "MediaItemType"
   },
   {
      code: MediaItemType_.VimeoVideo,
      literal: 'VimeoVideo',
      description: 'Vimeo Video',
      shortDescription: 'VV',
      listPriority: 7,

      typeName: "MediaItemType"
   }
]

export class MediaItemType implements IDomainModel {
   code: MediaItemType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: MediaItemType_): MediaItemType {
      return MediaItemTypes.find(d => d.code === code)
   }
}
